import React, { type ReactElement } from 'react';
import { translate } from '#packages/i18n';
import * as util from '#packages/util';

import TopBarButton from '../../topBarButton/topBarButtonWithTooltip';
import { progressButtonClassNames } from '../../topBarComponent/topBarData';

import type { ProgressStatus } from '#packages/constants';

interface BackToEditorButtonProps {
  disabled?: boolean;
  primary?: boolean;
  label?: string;
  tooltip?: ReactElement | string;
  onClick: () => void;
  status?: ProgressStatus;
}

function BackToEditorButton(props: BackToEditorButtonProps) {
  return (
    <TopBarButton
      disabled={props.disabled}
      label={props.label}
      onClick={props.onClick}
      tooltip={props.tooltip}
      primary={props.primary}
      className={util.cx(
        { 'top-bar-back-to-editor-btn': !props.primary },
        progressButtonClassNames[props.status],
      )}
      automationId="top-bar-button-back-to-editor"
    />
  );
}

BackToEditorButton.defaultProps = {
  label: translate('TOPBAR_BACK_TO_EDITOR'),
};

export default BackToEditorButton;
